/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
import format from 'date-fns/format';
import german from 'date-fns/locale/de';

import Model from './Model';
import Sectors from '../data/Sectors';
import AssessmentAnswer from './AssessmentAnswer';
import CheckAnswer from './CheckAnswer';
import Customer from './Customer';
import Coach from './Coach';
import ReportItem from './ReportItem';
// import Countries from '../data/Countries';

import store from '../store';

const userId = () => (store.getters['user/isAuthenticated'] ? store.getters['user/user'].resourceId : null);

let scoreToApi = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
};
let scoreFromApi = scoreToApi;

if (process.env.VUE_APP_SCORES === '1-5') {
    scoreToApi = {
        1: 0,
        2: 2,
        3: 5,
        4: 8,
        5: 10,
    };

    scoreFromApi = {
        0: 1,
        1: 1,
        2: 2,
        3: 2,
        4: 3,
        5: 3,
        6: 3,
        7: 4,
        8: 4,
        9: 5,
        10: 5,
    };
}

export default class Assessment extends Model {
    static get defaultScores() {
        const scores = Object.keys(scoreToApi);

        return {
            min: Number(scores[0]),
            mid: Math.floor((Number(scores[0]) + Number(scores[scores.length - 1])) / 2),
            max: Number(scores[scores.length - 1]),
        };
    }

    static get scoreToApi() {
        return scoreToApi;
    }

    static get scoreFromApi() {
        return scoreFromApi;
    }

    constructor(...atributtes) {
        super(...atributtes);

        if (atributtes.length) {

            // Countries.find(this.organisationCountry).then((item) => {
            //     this.organisationCountryLabel = item.label;
            // });
        }
    }

    static getAdminList() {
        return Assessment
            .params({
                properties: {
                    0: 'id',
                    1: 'createdAt',
                    2: 'checkCompletedAt',
                    3: 'assessmentCompletedAt',
                    4: 'reportCompletedAt',
                    5: 'sector',
                    customer: ['name', 'website', 'street', 'postcode', 'location', 'country'],
                    reportItems: ['score', 'totalScorePossible'],
                },
            })
            .get();
    }

    // noinspection JSMethodCanBeStatic
    resource() {
        return 'assessments';
    }

    get coach() {
        return this.customer.coach;
    }

    get screenshot() {
        return `${this.baseURL()}/assessments/${this.id}/screenshot`;
    }

    get readableCreatedAt() {
        return format(new Date(this.createdAt), 'DD.MM.YYYY HH:mm');
    }

    get longCreatedAt() {
        return format(new Date(this.createdAt), 'DD. MMMM YYYY HH:mm', { locale: german });
    }

    get invoiceDate() {
        if (this.reportCompletedAt) {
            return format(this.reportCompletedAt, 'DD. MMMM YYYY', { locale: german });
        }

        return format(this.createdAt, 'DD. MMMM YYYY', { locale: german });
    }

    get printableCreatedAt() {
        return format(new Date(this.createdAt), 'YYYY-MM-DD');
    }

    get readableOrganisationWebsite() {
        return this.organisationWebsite.replace(/^https?:\/\/([^/]+).*$/, '$1');
    }

    get readableContactGender() {
        switch (this.contactGender) {
            case 'm':
                return 'Herr';

            case 'f':
                return 'Frau';

            default:
                return '';
        }
    }

    get checkAnswerCount() {
        return this.checkAnswers ? this.checkAnswers.length : 0;
    }

    get assessmentAnswerCount() {
        return this.assessmentAnswers ? this.assessmentAnswers.length : 0;
    }

    get reportItemsCount() {
        return this.reportItems ? this.reportItems.length : 0;
    }


    /* ******************************** *
     *  (Potentially) Async Properties  *
     * ******************************** */

    async getCustomer() {
        return new Customer(this.customer);
    }

    async getCoach() {
        return (await this.getCustomer()).getCoach();
    }

    async getCheckAnswers() {
        if (!this.checkAnswers) {
            return [];
        }

        return this.checkAnswers.map(data => new CheckAnswer(data));
    }

    async getAssessmentAnswers() {
        if (!this.assessmentAnswers) {
            return [];
        }

        return this.assessmentAnswers.map(data => new AssessmentAnswer(data));
    }

    async getReportItems() {
        if (!this.reportItems || !this.reportItems.length) {
            return [];
        }

        return this.reportItems.map(data => new ReportItem(data));
    }

    async getSector() {
        if (!this.sector) {
            return null;
        }

        return Sectors.findResource(this.sector);
    }


    /* ******* *
     *  Types  *
     * ******* */

    get stateLead() {
        return this.isInvited && !this.isCheckCompleted;
    }

    get stateAssessment() {
        return this.isCheckCompleted && !this.isAssessmentCompleted;
    }

    get stateReport() {
        return this.isAssessmentCompleted && !this.isReportCompleted;
    }

    get stateArchived() {
        return this.isReportCompleted;
    }

    /* ************ *
     *  Invitation  *
     * ************ */

    get isInvited() {
        return this.invitedAt !== null;
    }

    get longInvitedAt() {
        return this.invitedAt ? format(new Date(this.invitedAt), 'DD. MMMM YYYY HH:mm', { locale: german }) : '';
    }

    async getInvitedBy() {
        if (this.invitedBy === null) {
            return null;
        }

        return Coach.find(this.invitedBy);
    }


    /* ******* *
     *  Check  *
     * ******* */

    get isCheckCompleted() {
        return this.checkCompletedAt !== null;
    }

    get longCheckCompletedAt() {
        return this.checkCompletedAt
            ? format(new Date(this.checkCompletedAt), 'DD. MMMM YYYY HH:mm', { locale: german })
            : '';
    }

    async getCheckCompletedBy() {
        if (this.checkCompletedBy === null) {
            return null;
        }

        if (this.checkCompletedBy instanceof Object) {
            return new Coach(this.checkCompletedBy);
        }

        return Coach.find(this.checkCompletedBy);
    }

    setCheckCompleted(answers) {
        this.checkCompletedAt = format(new Date(), 'YYYY-MM-DDTHH:mm:ss');
        this.checkCompletedBy = userId();
        this.checkAnswers = answers;
    }


    /* ************ *
     *  Assessment  *
     * ************ */

    get isAssessmentCompleted() {
        return this.assessmentCompletedAt !== null;
    }

    get longAssessmentCompletedAt() {
        return this.assessmentCompletedAt
            ? format(new Date(this.assessmentCompletedAt), 'DD. MMMM YYYY HH:mm', { locale: german })
            : '';
    }

    async getAssessmentCompletedBy() {
        if (this.assessmentCompletedBy === null) {
            return null;
        }

        if (this.assessmentCompletedBy instanceof Object) {
            return new Coach(this.assessmentCompletedBy);
        }

        return Coach.find(this.assessmentCompletedBy);
    }

    updateAnswers(answers, complete = false) {
        this.assessmentAnswers = answers;

        if (complete) {
            this.assessmentCompletedAt = format(new Date(), 'YYYY-MM-DDTHH:mm:ss');
            this.assessmentCompletedBy = userId();
        }
    }


    /* ******** *
     *  Report  *
     * ******** */

    get isReportStarted() {
        return this.reportLastSavedAt !== null;
    }

    get isReportCompleted() {
        return this.reportCompletedAt !== null;
    }

    get longReportCompletedAt() {
        return this.reportCompletedAt
            ? format(new Date(this.reportCompletedAt), 'DD. MMMM YYYY HH:mm', { locale: german })
            : '';
    }

    async getReportCompletedBy() {
        if (this.reportCompletedBy === null) {
            return null;
        }

        if (this.reportCompletedBy instanceof Object) {
            return new Coach(this.reportCompletedBy);
        }

        return Coach.find(this.reportCompletedBy);
    }

    updateReport(comment, items) {
        this.reportComment = comment;
        this.reportItems = items;
        this.reportLastSavedAt = format(new Date(), 'YYYY-MM-DDTHH:mm:ss');
    }

    setReportCompleted() {
        this.reportCompletedAt = format(new Date(), 'YYYY-MM-DDTHH:mm:ss');
        this.reportCompletedBy = userId();
    }

    get reportOverallScore() {
        if (!this.reportItems || !this.reportItems.length) {
            return null;
        }

        const possible = this.reportItems.reduce((t, i) => t + i.totalScorePossible, 0);
        const score = this.reportItems.reduce((t, i) => t + i.score, 0);

        return (100 / possible) * score;
    }
}
